module.exports = __webpack_public_path__ + "static/media/headerPicRight1.4a6221d1.svg";